import { render, staticRenderFns } from "./elementsPeriodicTable.vue?vue&type=template&id=4515e09f&scoped=true"
import script from "./elementsPeriodicTable.vue?vue&type=script&lang=js"
export * from "./elementsPeriodicTable.vue?vue&type=script&lang=js"
import style0 from "./elementsPeriodicTable.vue?vue&type=style&index=0&id=4515e09f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4515e09f",
  null
  
)

export default component.exports